export default function () {
  this.route("transcript", { path: "/chat-transcript/:secret" });
}
